import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { KPI } from '../../../@core/api';

import { NbSelectModule, NbOptionModule } from '@nebular/theme';

@Component({
    selector: 'app-objective-type-selector',
    templateUrl: './objective-type-selector.component.html',
    styleUrls: ['./objective-type-selector.component.scss'],
    standalone: true,
    imports: [NbSelectModule, NbOptionModule, TranslateModule]
})
export class ObjectiveTypeSelectorComponent implements OnInit {

  @Output() trajectoryChanged = new EventEmitter<KPI.TrajectorySelector>();

  public evaluationSelectorOptions = [
    {
      value: KPI.EvaluationSelector.BUILDINGS_COUNT,
      label: this.translate.instant('Sites count'),
      disabled: false,
    },
    {
      value: KPI.EvaluationSelector.SURFACE,
      label: this.translate.instant('Surface'),
      disabled: true,
    },
    {
      value: KPI.EvaluationSelector.ASSET_VALUE,
      label: this.translate.instant('Asset value'),
      disabled: true,
    },
  ];

  public trajectorySelectorOptions = [
    {
      value: KPI.TrajectorySelector.CARBON,
      label: this.translate.instant('Carbon'),
      disabled: false,
    },
    {
      value: KPI.TrajectorySelector.ENERGY,
      label: this.translate.instant('Energy'),
      disabled: false,
    },
  ];

  public selectedEval = KPI.EvaluationSelector.BUILDINGS_COUNT;
  public selectedTraj = KPI.TrajectorySelector.CARBON;

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
  }

  onTrajectoryChange(value: KPI.TrajectorySelector): void {
    this.trajectoryChanged.emit(value);
  }

}
